import api from "../api";
import { updateErrorMessage } from "../commonSlice";

const UserApi = api.injectEndpoints({
    endpoints: (builder) => ({
        Login: builder.mutation({
            async queryFn(credentials, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/auth/login",
                        method: "POST",
                        body: credentials,
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore login",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Login effettuato",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),

        Register: builder.mutation({
            async queryFn(userData, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/auth/register",
                        method: "POST",
                        body: userData,
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore registrazione",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Registrazione completata",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),

        Create: builder.mutation({
            async queryFn(userData, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/auth/create",
                        method: "POST",
                        body: userData,
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore registrazione",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Creazione completata",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),

        Me: builder.query({
            query: () => ({
                url: "/user/me",
                method: "GET",
            }),
            providesTags: ['User']
        }),
        ResetPassword: builder.query({
            query: ({email}) => ({
                url: `/auth/reset-password?email=${encodeURIComponent(email)}`,
                method: "GET",
            }),
            providesTags: ['User']
        }),

        Logout: builder.mutation({
            async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/auth/logout",
                        method: "POST",
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore logout",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Logout effettuato",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),

        ResetPasswordPost: builder.mutation({
            async queryFn(data, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/auth/reset-password",
                        method: "POST",
                        body: data,
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore reset password",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Reset password inviato",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),

        DeleteAccount: builder.mutation({
            async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/user/delete",
                        method: "DELETE",
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore eliminazione account",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Account eliminato con successo",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),

        CreateChat: builder.mutation({
            async queryFn(chatData, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/chat/create",
                        method: "POST",
                        body: chatData,
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore registrazione",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Registrazione completata",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),

        Operators: builder.query({
        query: () => ({
            url: "/user/operators",
            method: "GET",
        }),
        providesTags: ['User']
    }),
        AllAvailableOperators: builder.query({
            query: () => ({
                url: "/info/operator/all",
                method: "GET",
            })
        }),

        Chats: builder.query({
            query: () => ({
                url: "/chat/all",
                method: "GET",
            }),
            providesTags: ['User']
        }),

        AllOperators:builder.query({
            query: () => ({
                url: "/user/operator/all",
                method: "GET",
            }),
            providesTags: ['User']
        }),
        SetAvailability: builder.mutation({
            async queryFn(slotsData, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/user/operator/calendar",
                        method: "PUT",
                        body: slotsData,
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore calendar",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Calendar modificato",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),
        DeleteAvailability: builder.mutation({
            async queryFn(index, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/user/operator/calendar",
                        method: "DELETE",
                        body: index,
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore calendar",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Calendar modificato",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),
        Availability:builder.query({
            query: () => ({
                url: "/user/operator/calendar",
                method: "GET",
            }),
            providesTags: ['User']
        }),

    }),
    overrideExisting: false,
});

export const {
    useLoginMutation,
    useRegisterMutation,
    useCreateMutation,
    useSetAvailabilityMutation,
    useDeleteAvailabilityMutation,
    useMeQuery,
    useLazyResetPasswordQuery,
    useChatsQuery,
    useAvailabilityQuery,
    useLazyMeQuery,
    useLazyOperatorsQuery,
    useAllAvailableOperatorsQuery,
    useAllOperatorsQuery,
    useCreateChatMutation,
    useLogoutMutation,
    useResetPasswordPostMutation,
    useDeleteAccountMutation,
} = UserApi;
